import apiClient from '@/scripts/api/apiClient';

/**
 * Video File API endpoints
 */

// Query key factories
export const videoFileKeys = {
  getAllVideoFiles: () => ['get', 'videoFiles'],
  getVideoFile: (videoFileId) => ['get', 'videoFiles', videoFileId],
  updateVideoFile: (videoFileId) => ['update', 'videoFiles', videoFileId],
  deleteVideoFile: (videoFileId) => ['delete', 'videoFiles', videoFileId],
  getVideoFileComments: (videoFileId) => ['get', 'videoFiles', videoFileId, 'comments'],
  createVideoFileComment: (videoFileId) => ['create', 'videoFiles', videoFileId, 'comments'],
};

/**
 * Get all video files
 * @returns {Promise<Array>} List of video files
 */
export const getAllVideoFiles = async () => {
  const response = await apiClient.get('/api/video-files');
  return response.data;
};

/**
 * Get a specific video file by ID
 * @param {string} id - Video file ID
 * @returns {Promise<Object>} Video file details
 */
export const getVideoFile = async (id) => {
  const response = await apiClient.get(`/api/video-files/${id}`);
  return response.data;
};

/**
 * Update a video file
 * @param {string} id - Video file ID
 * @param {Object} data - Video file data to update
 * @returns {Promise<Object>} Updated video file
 */
export const updateVideoFile = async (id, data) => {
  const response = await apiClient.put(`/api/video-files/${id}`, data);
  return response.data;
};

/**
 * Delete a video file
 * @param {string} id - Video file ID
 * @returns {Promise<Object>} Response data
 */
export const deleteVideoFile = async (id) => {
  const response = await apiClient.delete(`/api/video-files/${id}`);
  return response.data;
};

/**
 * Get all comments for a video file
 * @param {string} videoFileId - Video file ID
 * @returns {Promise<Array>} List of comments
 */
export const getVideoFileComments = async (videoFileId) => {
  const response = await apiClient.get(`/api/video-files/${videoFileId}/comments`);
  return response.data;
};

/**
 * Create a new top-level comment for a video file
 * @param {string} videoFileId - Video file ID
 * @param {Object} commentData - Comment data with text and timestamp
 * @returns {Promise<Object>} Created comment
 */
export const createVideoFileComment = async (videoFileId, commentData) => {
  const response = await apiClient.post(`/api/video-files/${videoFileId}/comments`, commentData);
  return response.data;
};
